import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';
import { trackEvent } from '../utils/analytics';

const FAQ = () => {
  const { t } = useLanguage();

  const faqs = [
    {
      q: t("faq.q1"),
      a: t("faq.a1")
    },
    {
      q: t("faq.q2"),
      a: t("faq.a2")
    },
    {
      q: t("faq.q3"),
      a: t("faq.a3")
    }
  ];

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight">
            {t('faq.title')}
          </h2>
          <p className="text-lg text-slate-600">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div 
              key={idx} 
              className={`border rounded-2xl transition-colors duration-300 ${openIndex === idx ? 'border-indigo-200 bg-indigo-50/30' : 'border-slate-200 bg-white hover:border-slate-300'}`}
            >
              <button
                className="w-full flex justify-between items-center p-6 text-left"
                onClick={() => {
                  const nextIndex = openIndex === idx ? null : idx;
                  if (nextIndex !== null) {
                    trackEvent('faq_expand', { question: faq.q });
                  }
                  setOpenIndex(nextIndex);
                }}
              >
                <span className="font-semibold text-slate-900 pr-4">{faq.q}</span>
                <SafeIcon 
                  name="ChevronDown" 
                  className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === idx ? 'rotate-180 text-indigo-600' : ''}`} 
                />
              </button>
              
              <AnimatePresence>
                {openIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="p-6 pt-0 text-slate-600 text-sm leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-slate-600 text-lg">
            {t('faq.stillQuestions')}{' '}
            <a 
              href="https://help.bookmein.events/" 
              target="_blank" 
              rel="noopener noreferrer" 
              onClick={() => trackEvent('faq_click_help_center')}
              className="text-indigo-600 font-semibold hover:text-indigo-700 transition-colors inline-flex items-center gap-1.5"
            >
              {t('faq.helpCenterLink')}
              <SafeIcon name="ArrowRight" className="w-4 h-4" />
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;